var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "col-12 d-flex flex-column align-items-center pb-5",
      attrs: { id: "mainWrapper" },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "styleNames col-12 col-md-8 d-flex justify-content-around mb-4",
        },
        _vm._l(this.dataArray, function (style, index) {
          return _c(
            "div",
            {
              key: index,
              on: {
                click: function ($event) {
                  _vm.styleSelected = style.name
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-light cursorPointer",
                  class:
                    _vm.styleSelected === style.name
                      ? "selectedTextStyle"
                      : "textStyle",
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(style.name) + "\n            "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "styleImages col-12" },
        [
          _vm._l(this.dataArray, function (style, index) {
            return [
              style.name === _vm.styleSelected
                ? [
                    _vm._l(style.images, function (image, index) {
                      return [
                        _c("div", { staticClass: "imageWrapper" }, [
                          _c("img", {
                            staticClass: "aiImage",
                            attrs: { src: image },
                          }),
                        ]),
                      ]
                    }),
                  ]
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }